<template>
	<div class="w1">
	<div  class="DigitalEconomy_wrapper"><!-- DigitalEconomy_wrapper -->
		<el-skeleton :rows="20" :loading="loadingMask" animated>
			<template>
				<div class="DigitalEconomy_top"><h1>{{keyword}}</h1></div>
				
				
				<div class="group2b"><!-- group2b -->
					<div class="group2b_L"><!-- group2b_L -->
					
						<div class="report_nav_wrap"><!-- report_nav_wrap -->
							<div  class="report_nav_h"  :class="colid?'':'on'" ><i class="cei-icon icon-report"></i><router-link :to="{ name: 'theme', params: { pagetype: '1' }, query: { col : sourcecol }}">内容纵览</router-link></div>
							<div class="report_nav"><!-- report_nav -->
								<dl v-if="item.artcount" v-for="(item,index) in indexDataList">
									<template v-if="item.ChildList">
										<dt><router-link :to="{ name: 'theme', params: { pagetype: '2', colid: item.colID }, query: { col : sourcecol }}" :class="item.colID==colid?'on':''" >{{item.colName}}</router-link></dt>
										<dd v-for="(citem,cindex) in item.ChildList">
											<router-link v-if="citem.colID&&citem.artLst.length" :to="{ name: 'theme', params: { pagetype: '3', colid: citem.colID }, query: { col : sourcecol }}" :class="citem.colID==colid?'on':''" >{{citem.colName}}</router-link>
											<router-link v-else-if="citem.tagId&&citem.artLst.length" :to="{ name: 'theme', params: { pagetype: '4', colid: citem.tagId }, query: { col : sourcecol }}" :class="citem.tagId==colid?'on':''" >{{citem.tagName}}</router-link>
										</dd>
									</template>
									<template v-else>
										<dt>
											<router-link v-if="item.colID&&item.Type!='4'" :to="{ name: 'theme', params: { pagetype: '3', colid: item.colID }, query: { col : sourcecol }}" :class="item.colID==colid?'on':''">{{item.colName}}</router-link>
											<router-link v-else-if="item.colID" :to="{ name: 'theme', params: { pagetype: '4', colid: item.colID }, query: { col : sourcecol }}" :class="item.colID==colid?'on':''">{{item.colName}}</router-link>
										</dt>
									</template>
								</dl>
								<!-- <dl>
									<dt><a href="">国内进展</a></dt>
								</dl>
								<dl>
									<dt><a href="">国外经验</a></dt>
								</dl>
								<dl>
									<dt><a href="">前瞻观点</a></dt>
								</dl> -->
							
							</div><!-- /report_nav -->
						</div><!-- /report_nav_wrap -->
				
					</div><!-- /group2b_L -->
					
					<themelist v-if="pagetype==3||pagetype==4" v-bind:colname="colname" v-bind:sourcecol="sourcecol"></themelist>
					
					<themeindex v-else v-bind:resultlist="selDataList" v-bind:sourcecol="sourcecol"></themeindex>
					
				</div><!-- /group2b -->
					
				
				
				
				<div class="m_b1"></div>
			</template>
		</el-skeleton>
						
					
					
					
	</div><!-- /DigitalEconomy_wrapper -->
	</div>
</template>

<script>
	import themeindex from '@/components/theme-index.vue'
	import themelist from '@/components/theme-list.vue'
	export default {
		data() {
			return {
				loadingMask: false,
				keyword: '',
				pagetype:'',
				keytype:'',
				colid:'',
				colname:'',
				sourcecol:'',
				indexDataList: [],
				selDataList:[],
				pageNum: 1,
				pageSize: 10,
				moreTotalCount: '',
				moreDataList:[]
			}
		},
		components:{
			themeindex,
			themelist
		},
		watch: {
			$route(to, from) {
				if (to.params.colid != from.params.colid) {
					this.keyword = this.$route.params.searchword;
					this.pagetype=this.$route.params.pagetype;
					this.colid=this.$route.params.colid;
					this.sourcecol=this.$route.query.col?this.$route.query.col:'';
					this.selcol();
					document.body.scrollTop = 0;
					document.documentElement.scrollTop = 0;
				}
			}
		},
		mounted: function() {
			this.keyword = this.$route.params.searchword;
			this.pagetype=this.$route.params.pagetype;
			this.colid=this.$route.params.colid;
			this.sourcecol=this.$route.query.col?this.$route.query.col:'';
			document.title=this.keyword+'-专题-中经专网';
			this.$track([
				['pagetype','场景检索'],
				['reqtype','2'],
				['searchkeyword',this.keyword],
				['column',this.colid]
			]);
			this.getallfnc();
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		methods: {
			selcol:function(){
				if(this.pagetype=='2'&&this.colid){
					for(var i=0;i<this.indexDataList.length;i++){
						if(this.indexDataList[i].colID==this.colid){
							this.selDataList=[this.indexDataList[i]];
							break;
						}
					}
				}
				else if(this.pagetype=='3'&&this.colid){
					for(var i=0;i<this.indexDataList.length;i++){
						if(this.indexDataList[i].colID==this.colid){
							this.colname=this.indexDataList[i].colName;
							break;
						}
						if(this.indexDataList[i].ChildList){
							for(var j=0;j<this.indexDataList[i].ChildList.length;j++){
								if(this.indexDataList[i].ChildList[j].colID==this.colid){
									this.colname=this.indexDataList[i].ChildList[j].colName;
									break;
								}
							}
						}
					}
				}
				else if(this.pagetype=='4'&&this.colid){
					for(var i=0;i<this.indexDataList.length;i++){
						if(this.indexDataList[i].colID==this.colid){
							this.colname=this.indexDataList[i].colName;
							break;
						}
						if(this.indexDataList[i].ChildList){
							for(var j=0;j<this.indexDataList[i].ChildList.length;j++){
								if(this.indexDataList[i].ChildList[j].tagId==this.colid){
									this.colname=this.indexDataList[i].ChildList[j].tagName;
									break;
								}
							}
						}
					}
				}
				else{
					this.selDataList=this.indexDataList;
				}
			},
			getallfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'SearchInfo/ThemeListInfo',
						responseType: 'json',
						params: {
							strKey: this.keyword,
							ColAlias: this.sourcecol,
						},
					})
					.then(function(response) {
						// console.log(response);
						// debugger;
						_this.indexDataList = response.data.data.data.column;
						for(var i=0;i<_this.indexDataList.length;i++){
							var tempcount=0;
							if(_this.indexDataList[i].ChildList){
								for(var j=0;j<_this.indexDataList[i].ChildList.length;j++){
									tempcount+=_this.indexDataList[i].ChildList[j].artLst.length;
								}
							}
							else{
								tempcount+=_this.indexDataList[i].artLst.length;
							}
							_this.indexDataList[i].artcount=tempcount;
						}
						_this.loadingMask = false;
						_this.selcol();
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});;
			},
		}
	}
</script>

<style>
</style>
